import React from 'react';
import { Card } from '../../ui/card';
import { QrCode, TrendingUp, Users, Store } from 'lucide-react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';

const OverviewTab = ({ overview, partners }) => {
  if (!overview) return null;
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: 'Total de Scans', value: overview.total_scans, Icon: QrCode, color: 'orange' },
          { label: 'Scans Hoje', value: overview.scans_today, Icon: TrendingUp, color: 'blue' },
          { label: 'Leads Capturados', value: overview.total_leads, Icon: Users, color: 'green' },
          { label: 'Parceiros Ativos', value: overview.total_partners, Icon: Store, color: 'purple' },
        ].map(({ label, value, Icon, color }) => (
          <Card key={label} className="p-5">
            <div className={`w-10 h-10 rounded-lg bg-${color}-100 flex items-center justify-center mb-3`}>
              <Icon className={`w-5 h-5 text-${color}-600`} />
            </div>
            <p className="text-2xl font-bold text-gray-800">{value}</p>
            <p className="text-sm text-gray-500">{label}</p>
          </Card>
        ))}
      </div>

      {overview.daily_scans?.length > 0 && (
        <Card className="p-6">
          <h3 className="font-bold text-gray-800 mb-4">Scans por dia (últimos 30 dias)</h3>
          <ResponsiveContainer width="100%" height={240}>
            <BarChart data={overview.daily_scans}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis dataKey="date" tick={{ fontSize: 11 }} tickFormatter={(d) => d.slice(5)} />
              <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
              <Tooltip formatter={(v) => [v, 'Scans']} labelFormatter={(d) => `Data: ${d}`} />
              <Bar dataKey="count" fill="#f97316" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </Card>
      )}

      <Card className="p-6">
        <h3 className="font-bold text-gray-800 mb-4">Ranking de Parceiros</h3>
        <div className="space-y-3">
          {[...partners]
            .sort((a, b) => (b.total_scans || 0) - (a.total_scans || 0))
            .slice(0, 8)
            .map((p, i) => (
              <div key={p.id} className="flex items-center gap-3">
                <span className="w-6 h-6 rounded-full bg-orange-100 text-orange-700 text-xs font-bold flex items-center justify-center flex-shrink-0">
                  {i + 1}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex justify-between items-center mb-1">
                    <p className="text-sm font-medium text-gray-800 truncate">{p.name}</p>
                    <span className="text-sm font-bold text-orange-600 ml-2">{p.total_scans || 0}</span>
                  </div>
                  <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
                    <div
                      className="h-full bg-orange-500 rounded-full"
                      style={{
                        width: `${partners.length > 0
                          ? ((p.total_scans || 0) / Math.max(...partners.map(x => x.total_scans || 0), 1)) * 100
                          : 0}%`
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          {partners.length === 0 && (
            <p className="text-gray-400 text-sm text-center py-4">Nenhum parceiro cadastrado ainda.</p>
          )}
        </div>
      </Card>
    </div>
  );
};

export default OverviewTab;
